const similarity = require("similarity");
const { SIMILARITY_THRESHOLD } = require("../constants");

/**
 * İki string arasındaki benzerliği kontrol eder
 * @param {string} str1 - İlk string
 * @param {string} str2 - İkinci string
 * @param {number} threshold - Benzerlik eşiği (varsayılan: CLOSE_MATCH = 0.80)
 * @returns {boolean} Benzerlik eşiği aşıldıysa true
 */
function isSimilar(str1, str2, threshold = SIMILARITY_THRESHOLD.CLOSE_MATCH) {
  if (!str1 || !str2) {
    return false;
  }

  return similarity(str1, str2) > threshold;
}

/**
 * İki string arasındaki benzerlik skorunu döndürür
 * @param {string} str1 - İlk string
 * @param {string} str2 - İkinci string
 * @returns {number} Benzerlik skoru (0-1 arası)
 */
function getSimilarityScore(str1, str2) {
  if (!str1 || !str2) {
    return 0;
  }

  return similarity(str1, str2);
}

/**
 * Bir string ile bir dizi string arasındaki en iyi eşleşmeyi bulur
 * @param {string} target - Hedef string
 * @param {Array<string>} candidates - Aday stringler
 * @param {number} threshold - Minimum benzerlik eşiği
 * @returns {Object|null} En iyi eşleşme { value: string, score: number } veya null
 */
function findBestMatch(target, candidates, threshold = SIMILARITY_THRESHOLD.CLOSE_MATCH) {
  if (!target || !candidates || !Array.isArray(candidates) || candidates.length === 0) {
    return null;
  }

  let bestMatch = null;
  let bestScore = 0;

  for (const candidate of candidates) {
    if (!candidate) continue;

    const score = similarity(target, candidate);
    if (score > bestScore && score > threshold) {
      bestScore = score;
      bestMatch = candidate;
    }
  }

  return bestMatch ? { value: bestMatch, score: bestScore } : null;
}

/**
 * String'i normalize eder (küçük harf + boşluk temizleme)
 * @param {string} str - Normalize edilecek string
 * @returns {string} Normalize edilmiş string
 */
function normalizeString(str) {
  if (!str) return '';

  return str.toString().toLowerCase().replace(/\s/g, '');
}

module.exports = {
  isSimilar,
  getSimilarityScore,
  findBestMatch,
  normalizeString
};
